// extracted by mini-css-extract-plugin
module.exports = {"primary":"PrimaryButton_primary__3L2LN"};